import { createDefaultRoles } from 'garaje/mirage/helpers/roles';
/**
 * This function creates models that we use in multiple scenarios
 *
 * @param {Object} server       Mirage Server
 */
export default function (server) {
  const company = server.create('company', 'withConfig', 'withConfiguration', 'withBillingCompany', 'withGlobalAdmin', {
    name: 'Cool Chip',
  });

  const SFLocation = server.create('location', 'withConfig', {
    name: 'SF',
    address: '461 2nd St, San Francisco, CA 94546',
    company,
  });

  const NYLocation = server.create('location', 'withConfig', {
    name: 'NY',
    address: '767 Fifth Avenue, New York, NY 10153',
    company,
  });

  createDefaultRoles(server);

  return {
    company,
    locations: [SFLocation, NYLocation],
  };
}
